import $ from 'jquery';
import { modifyState } from '~src/state';
import { showSidebarTab, hideAllSidebarTabs } from '~src/sidebarLegacy';
import editorConfig from '~config/editorConfig';
import { handleSidebarBackgrounds } from '~src/sidebar/index';

export const magicFrameChangeBackgroundPhoto = async () => {
  modifyState('sidebarCurrentBackgroundsTag', editorConfig.magicFrameTag);
  modifyState('magicFrameSelectBackgroundPhotoActive', true);
  // Open the sidebar immediately to avoid perceived stall
  hideAllSidebarTabs();
  showSidebarTab('manifesti');
  await handleSidebarBackgrounds();
  const tagId = window.editorConfig.sidebarTags.items.find(
    (tag) => tag.name === editorConfig.magicFrameTag
  );
  $('#select-ricerca-backgrounds').val(tagId.objectId).trigger('change');
};
